import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-card-body',
  templateUrl: 'card-body.component.html',
  styleUrl: './card-body.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CardBodyComponent {}
